import React from 'react';
import { AlertTriangle, Mail, LogOut } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';

interface SuspensionCheckProps {
  children: React.ReactNode;
}

export const SuspensionCheck: React.FC<SuspensionCheckProps> = ({ children }) => {
  const { user, signOut } = useAuth();

  const handleSignOut = async () => {
    await signOut();
  };

  // This component is only rendered when user.isSuspended is true
  // so we don't need to check suspension status here
  return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-6">
              <AlertTriangle className="h-8 w-8 text-red-600" />
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Account Suspended
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Your account has been suspended and you no longer have access to this application.
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-blue-600 mt-0.5" />
                <div>
                  <h3 className="text-sm font-medium text-gray-900">Need Help?</h3>
                  <p className="text-sm text-gray-600 mt-1">
                    If you believe this is an error, please contact the site administrator to resolve this issue.
                  </p>
                </div>
              </div>
              
              <div className="pt-4 border-t border-gray-200">
                <button
                  onClick={handleSignOut}
                  className="w-full flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  <LogOut className="h-4 w-4 mr-2" />
                  Sign Out
                </button>
              </div>
            </div>
          </div>

          <div className="text-center">
            <p className="text-sm text-gray-500">
              For technical support, please contact your system administrator.
            </p>
          </div>
        </div>
      </div>
    );
};
